import { render, staticRenderFns } from "./CharactersItemRandom.vue?vue&type=template&id=45d16629&"
import script from "./CharactersItemRandom.vue?vue&type=script&lang=js&"
export * from "./CharactersItemRandom.vue?vue&type=script&lang=js&"
import style0 from "./CharactersItemRandom.vue?vue&type=style&index=0&id=45d16629&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports